import { useHandler } from "@chatbotgang/etude/react/useHandler";

import { interlude } from "@/interlude";

interface MutationOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

/**
 * Disconnect Google Ads from the current org. Cascade-soft-deletes the
 * manager account record, all child ad accounts, and all conversion configs.
 */
export function useDeleteManagerAccount(options: MutationOptions = {}) {
  const handleSuccess = useHandler(() => {
    options.onSuccess?.();
  });
  const handleError = useHandler((error: unknown) => {
    options.onError?.(error);
  });
  return interlude.googleAds.useDeleteManagerAccount(undefined, {
    onSuccess: handleSuccess,
    onError: handleError,
  });
}
